import React from "react";

interface PillOption {
    value: string | number;
    label: string;
}

interface PillSelectorProps {
    options: PillOption[];
    value: string | number;
    onChange: (value: string | number) => void;
    className?: string;
}

const PillSelector: React.FC<PillSelectorProps> = ({
    options,
    value,
    onChange,
    className = "",
}) => {
    return (
        <div className={`flex flex-wrap gap-2 ${className}`}>
            {options.map((option) => {
                const isSelected = option.value === value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        onClick={() => onChange(option.value)}
                        className={`
              flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-all
              ${isSelected
                                ? "bg-accent text-accent-contrast"
                                : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
                            }
              
            `}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};

export default PillSelector;
